module.exports = "/_next/static/images/revamp-powerd-konfhub-logo-31f57f19225732d055f56cd5ec44af52.svg";